import { Layout } from '@components/commons';
import PublicationLocationTracker from '@contexts/PropertyListingPublications/components/shared/PublicationLocationTracker';
import {
  NavBar,
  ProcessActionBar,
  ProcessInfoBar,
} from '@contexts/PropertyListingPublications/components/shared';
import * as React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

export type PublicationLayoutProps = {
  children: React.ReactNode;
  actions: {
    primary: {
      name: string;
      onClick: () => void;
      disabled?: boolean;
    };
    disabled?: boolean;
  };
};

const Container = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  max-width: 629px;
  margin: auto;
  padding: 0 16px 80px 16px;
`;

const GlobalStyle = createGlobalStyle`
    body {
        background-color: #F8F8F8;
        padding-bottom: 80px;
    }
`;

function PublicationLayout(props: PublicationLayoutProps) {
  return (
    <Layout withoutFooter>
      <GlobalStyle />
      <PublicationLocationTracker />
      <NavBar />
      <ProcessInfoBar />
      <Container>
        {props.children}

        <ProcessActionBar
          disabled={props.actions.disabled}
          primary={props.actions.primary}
        />
      </Container>
    </Layout>
  );
}

export { PublicationLayout };
